export enum EventIds {
  alerts = 'alerts',
  reminders = 'reminders',
  updates = 'updates',
}
